import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { PublicLayout } from "../components/public/PublicLayout";
import { ArrowRight } from "lucide-react";

export default function OurStory() {
  const { t } = useLang();
  const navigate = useNavigate();
  useEffect(() => { document.title = "Our Story | Sambiva"; }, []);

  const sections = [
    { title: "Our Story", body: "Sambiva was created to make authentic foods easier to discover, enjoy and share. Inspired by Brazilian food culture and designed for modern European households, Sambiva combines familiar flavours with dependable product quality.", img: "https://images.unsplash.com/photo-1746635732995-ab5c6118d5a7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
    { title: "Our Food", body: "From toasted farofa and creamy beans to cloud-soft pão de queijo, every Sambiva product carries the warmth of the Brazilian table — made simple for everyday life.", img: "https://images.unsplash.com/photo-1709114107937-6dec855d9ab5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
    { title: "Our Values", body: "Authentic flavours, quality ingredients and everyday goodness. We believe good food should be dependable, honest and made for sharing.", img: "https://images.unsplash.com/photo-1766422526750-6099697a2dd5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
    { title: "Brazil to Europe", body: "Our ambition is simple: bring foods people love into more homes, more shops and more shared moments across Europe.", img: "https://images.unsplash.com/photo-1650855543392-44edbd4e03cf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  ];

  return (
    <PublicLayout>
      <section className="bg-sambiva-red text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-24 text-center">
          <p className="font-script text-3xl text-sambiva-yellow mb-3">From Brazil to the world</p>
          <h1 className="font-serif text-4xl sm:text-6xl mb-5">Global Flavours, Local Homes.</h1>
          <p className="text-white/90 text-lg max-w-2xl mx-auto">
            Sambiva brings the taste of Brazil into modern European kitchens — familiar, dependable and made for sharing.
          </p>
        </div>
      </section>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-20 space-y-20">
        {sections.map((s, i) => (
          <div key={i} className={`grid md:grid-cols-2 gap-10 items-center ${i % 2 ? "md:[direction:rtl]" : ""}`}>
            <div className="rounded-3xl overflow-hidden aspect-[4/3] [direction:ltr]">
              <img src={s.img} alt={s.title} className="w-full h-full object-cover" loading="lazy" />
            </div>
            <div className="[direction:ltr]">
              <h2 className="font-serif text-3xl text-sambiva-charcoal mb-4">{s.title}</h2>
              <p className="text-sambiva-muted text-lg leading-relaxed">{s.body}</p>
            </div>
          </div>
        ))}
      </div>

      <section className="bg-sambiva-green text-sambiva-cream">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-20 text-center">
          <p className="font-script text-3xl text-sambiva-yellow mb-3">Good food brings people together</p>
          <h2 className="font-serif text-3xl sm:text-4xl mb-6">Join us at the table.</h2>
          <button onClick={() => navigate("/products")} className="inline-flex items-center gap-2 bg-sambiva-yellow text-sambiva-charcoal font-semibold px-7 py-3.5 rounded-full hover:bg-white transition-colors">
            {t("common.viewProducts")} <ArrowRight size={16} />
          </button>
        </div>
      </section>
    </PublicLayout>
  );
}
